import { Nav } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { selectCurrentUser } from 'redux/user/user.selector';
import Paths from 'util/paths';
import {
  ACCOUNT_ROLE_ADMIN,
  ACCOUNT_ROLE_CHILD,
  ACCOUNT_ROLE_PARENT,
} from 'util/permission';
import { RouteMap } from 'util/routes';
import string from 'util/string';
// import { BsChevronRight, BsChevronDown } from 'react-icons/bs';
import './Menu.scss';
// import { useState } from 'react';
// import { nNU } from 'util/utils';

const Menu = () => {
  const currentUser = useSelector(selectCurrentUser);
  const location = useLocation();
  // const [subMenu, setSubMenu] = useState(true);
  const menu = [
    { path: Paths.user.list, name: string.ACCOUNT_MANAGEMENT },
    // { path: Paths.appuser.list, name: string.APP_USER_MANAGEMENT },
    // { path: Paths.appchannel.list, name: string.APP_CHANNEL_MANAGEMENT },
    { path: Paths.pocaccount.list, name: string.POC_ACCOUNT_MANAGEMENT },
    { path: Paths.pocchannel.list, name: string.POC_CHANNEL_MANAGEMENT },
    { path: Paths.coupon.coupon, name: string.APP_COUPON_LIST },
    { path: Paths.summary.summary, name: string.APP_SUMMARY },
    { path: Paths.invoice.invoice, name: string.APP_INVOICE },
    { path: Paths.calllogs.calllogs, name: string.CALLLOG },
    { path: Paths.channellogs.channellogs, name: string.CHANNELLOG },
    { path: Paths.servicecode.servicecode, name: string.APP_ADMIN_SERVICE_CODE },
    // { path: Paths.purchase.purchasedetails, name: string.APP_PC_MENU },
    // { path: Paths.fincode.user, name: string.FINCODE_TITLE },
    // { path: Paths.fincode.admin, name: string.FINCODE_TITLE },
    { path: Paths.notify.log, name: string.DEVICE_ALERT_HISTORY },
    { path: Paths.user.log, name: string.AUTHENTICATION_LOG },
    { path: Paths.policy.privacy2, name: string.POLICY_PRIVACY },
    { path: Paths.termsofuse.termsofuse2, name: string.TERMS_OF_USE },
    { path: Paths.links.links, name: string.APP_LINKS },
  ];
  //console.log(location);
  return (
    <>
      <Nav className="me-auto">
        {menu
          .filter((e) => {
            let permissions = RouteMap[ e.path ]?.permissions || [
              ACCOUNT_ROLE_ADMIN,
              ACCOUNT_ROLE_PARENT,
              ACCOUNT_ROLE_CHILD,
            ];
            return permissions.indexOf(currentUser.accountRole) !== -1;
          })
          .map((item, index) => (
            <>
              <Link
                className={`nav-link ${location.pathname === item.path ? '_current' : ''
                  }`}
                key={index}
                to={item.path}
              >
                {item.name}
              </Link>
            </>
          ))}
        {/* {
					<>
              <Link
                className={'nav-link'}
                // key={index}
                to={Paths.policy.privacy2}
              >
                {string.POLICY_PRIVACY}
              </Link>
					</>
				} */}
      </Nav>
    </>
  );
};

export default Menu;
